export const SportBannersService = {
    getBannersCount(bannersList) {
        return Array.isArray(bannersList) ? bannersList.length : 0;
    },

    getPlaceholderBanner(placeholderData, isMobile) {
        const device = isMobile ? 'mobile' : 'desktop';
        return [{
            actions: {
                banner: {
                    type: 0,
                    ActionID: '',
                },
                CTA: {
                    type: 0,
                    ActionID: '',
                },
                TnC: {
                    type: 0,
                    ActionID: '',
                },
            },
            content: {
                image: placeholderData.url,
                title: placeholderData.title,
                subtitle: placeholderData.subTitle,
                CTAtext: '',
                TnC: '',
            },
            details: {
                Device: device,
                banner_group: '',
                PnP: false,
            },
        }];
    }
};
